function HandoutList({ title, items }) {
  return (
    <div className="mt-8">
      <h2 className="text-2xl font-semibold text-gray-700 mb-4">{title}</h2>

      <div className="grid gap-4 sm:grid-cols-2">
        {items.map(({ title, link }) => (
          <a
            key={title}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="block p-4 border border-gray-200 bg-white rounded-lg hover:border-blue-400 hover:shadow transition"
          >
            <p className="font-medium text-blue-700">{title}</p>
          </a>
        ))}
      </div>
    </div>
  );
}

export default HandoutList;
